var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-hero-section"},[_c('div',{staticClass:"hero-content"},[_c('div',{staticClass:"hero-text"},[_c('h1',{staticClass:"hero-title"},[_c('span',{staticClass:"golden-text"},[_vm._v("Trust Your Trades, Philosophically.")]),_c('span',{staticClass:"subtitle"},[_vm._v("our Forex Partner in Wisdom.")])])])])])
}]

export { render, staticRenderFns }